var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreativeProcess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg5500",
    height: 512,
    viewBox: "0 0 16.933334 16.933334",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(148.923 -136.436)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path5208",
    d: "m-140.52677 137.22945c-3.35938 0-6.08439 2.75786-6.08439 6.15053.003 2.17713 1.17211 4.13397 2.97036 5.22655h6.22546c1.79995-1.09185 2.97181-3.04851 2.9745-5.22655 0-3.39267-2.72657-6.15053-6.08593-6.15053zm-6.40426.58396.79478.79323c.24793.28947.66257-.12517.3731-.3731l-.79323-.79479c-.31719-.24403-.58363.16568-.37465.37466zm12.56822-.37466-.79478.79479c-.27058.24958.12619.64471.37465.3731l.79323-.79323c.24927-.24592-.11605-.62127-.3731-.37466zm-6.16396 4.8178c1.16645 0 2.11718.93794 2.11718 2.09599v3.72484h-4.23282v-3.72484c0-1.15805.94919-2.09548 2.11564-2.09548zm5.36918 6.13916.79478.79478c.25009.25899.63347-.12651.3731-.37517l-.79323-.79272c-.25291-.26802-.59687.15089-.37465.37311zm-10.97866-.37311-.79478.79272c-.23938.24972.1246.6142.37465.37517l.79323-.79478c.25595-.2354-.12588-.62033-.3731-.37311zm3.49384 1.11311v.79322c-.00053.14633.11775.26532.26407.26562h3.70468c.14632-.00029.26463-.11929.26407-.26562v-.79323c-1.40721.002-2.82133 0-4.23282 0zm.29507 1.58802c-.16697.0173-.27582.18373-.22479.34365.27558.87543 1.08674 1.50792 2.04536 1.50792.9586 0 1.77131-.63249 2.0469-1.50792.0533-.17028-.0738-.34341-.25218-.34365z",
    "font-variant-ligatures": "normal",
    "font-variant-position": "normal",
    "font-variant-caps": "normal",
    "font-variant-numeric": "normal",
    "font-variant-alternates": "normal",
    "font-feature-settings": "normal",
    "text-indent": 0,
    "text-align": "start",
    "text-decoration-line": "none",
    "text-decoration-style": "solid",
    "text-decoration-color": "rgb(0,0,0)",
    "text-transform": "none",
    "text-orientation": "mixed",
    "white-space": "normal",
    "shape-padding": 0,
    isolation: "auto",
    "mix-blend-mode": "normal",
    "solid-color": "rgb(0,0,0)",
    "solid-opacity": 1,
    vectorEffect: "none",
    paintOrder: "normal"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreativeProcess);
export default __webpack_public_path__ + "static/media/creative-process.566f43993a68041ae7eb2e4811696cab.svg";
export { ForwardRef as ReactComponent };